module.exports = __webpack_public_path__ + "media/5x15.ee64432a.png";